import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo, Children, isValidElement, Fragment, cloneElement } from "react";
import PropTypes from "prop-types";
import { Pill } from "../pill/pill.es.js";
import { InputGroupWrapper, InputGroupPrefix, InputGroupMain, InputGroupSeparator, InputGroupItem, InputGroupSuffix } from "./input-group.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  magnitude: PropTypes.oneOf(["large", "medium", "small"]),
  prefix: PropTypes.node,
  separator: PropTypes.string,
  suffix: PropTypes.node,
  variant: PropTypes.oneOf(["input", "select"])
};
const defaultProps = {
  disabled: false,
  error: false,
  magnitude: "small",
  prefix: void 0,
  separator: "→",
  suffix: void 0,
  variant: "input"
};
const InputGroup = ({
  children,
  disabled,
  error,
  magnitude,
  prefix,
  separator,
  suffix,
  variant
}) => {
  const validChildren = useMemo(
    () => Children.toArray(children).filter(isValidElement),
    [children]
  );
  return /* @__PURE__ */ jsxs(InputGroupWrapper, { children: [
    prefix && /* @__PURE__ */ jsx(InputGroupPrefix, { children: /* @__PURE__ */ jsx(
      Pill,
      {
        adjoin: "left",
        appearance: error ? "error" : void 0,
        magnitude: "medium",
        children: prefix
      }
    ) }),
    /* @__PURE__ */ jsx(
      InputGroupMain,
      {
        disabled,
        error,
        prefixed: Boolean(prefix),
        suffixed: Boolean(suffix),
        variant,
        children: validChildren.map((child, i) => /* @__PURE__ */ jsxs(Fragment, { children: [
          i > 0 && /* @__PURE__ */ jsx(InputGroupSeparator, { content: separator }),
          /* @__PURE__ */ jsx(InputGroupItem, { children: cloneElement(child, {
            appearance: "bare",
            disabled,
            error,
            magnitude
          }) })
        ] }, child.key))
      }
    ),
    suffix && /* @__PURE__ */ jsx(InputGroupSuffix, { children: /* @__PURE__ */ jsx(
      Pill,
      {
        adjoin: "right",
        appearance: error ? "error" : void 0,
        magnitude: "medium",
        children: suffix
      }
    ) })
  ] });
};
InputGroup.propTypes = propTypes;
InputGroup.defaultProps = defaultProps;
export {
  InputGroup
};
